<template>
  <div class="w-fit">
    <loader :is-loading="isLoading" size="20" />
    <lf-dropdown
      v-if="!isLoading && taskStatus"
      :name="name"
      :value="taskStatus"
      :options="taskOptions"
      :disabled="disabled"
      :custom-z-index="customZIndex"
      :teleport-options="teleportOptions"
      @change="updateTaskStatus"
    >
      <template #toggle-button="{ toggle, value, menuOpen }">
        <div
          class="flex cursor-pointer items-center justify-center space-x-2 rounded-2xl px-3 h-7 text-xs font-semibold uppercase whitespace-nowrap"
          :class="[
            disabled ? 'pointer-events-none items-center' : 'justify-between',
            TASK_STATUSES_DISPLAY_OPTIONS[value as TaskStatuses].class,
          ]"
          @click.stop="toggle"
        >
          <span>
            {{ $t(TASK_STATUSES_DISPLAY_OPTIONS[value as TaskStatuses].label) }}
          </span>
          <icon-base
            v-if="!disabled"
            height="6"
            width="10"
            icon="dropdown-arrow"
            :class="{ 'rotate-180 transform': menuOpen }"
          />
        </div>
      </template>
    </lf-dropdown>
  </div>
</template>
<script setup lang="ts">
import { useI18n } from "vue-i18n";

import { TaskStatuses } from "@/enums/communicationLogs";
import { TASK_STATUSES_DISPLAY_OPTIONS } from "@/helpers/constants/communicationLogs";

import IconBase from "@/components/ui/IconBase.vue";
import Loader from "@/components/ui/Loader.vue";
import LfDropdown from "@/components/ui/inputs/LfDropdown.vue";

import type { DropdownTeleportOptions } from "@/components/ui/inputs/LfDropdown.vue";
import type { PropType } from "vue";

const { t } = useI18n();

defineProps({
  taskStatus: {
    type: String as PropType<TaskStatuses>,
    required: true,
  },
  name: {
    type: String,
    default: "status",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  customZIndex: {
    type: String,
  },
  teleportOptions: {
    type: Object as PropType<Partial<DropdownTeleportOptions>>,
  },
});

const emit = defineEmits<{
  change: [value: TaskStatuses];
}>();

const taskOptions = {
  [TaskStatuses.todo]: t("ACTIVITY.TASK.TO_DO"),
  [TaskStatuses.in_progress]: t("ACTIVITY.TASK.IN_PROGRESS"),
  [TaskStatuses.done]: t("ACTIVITY.TASK.DONE"),
};

const updateTaskStatus = (taskStatus: string | number) => {
  emit("change", taskStatus as TaskStatuses);
};
</script>
